import { System } from './../../shared-components/System';
import { FamilyRegistrationYear } from './family-registration-year.model';
import { FamilyRegistrationAddressSettings } from './family-registration-household-addresses/family-registration-address-settings.model';
import { Injectable } from '@angular/core';
import { FamilyRegistration } from './family-registration.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FamilyRegistrationStudent } from './family-registration-student.model';

@Injectable()
export class FamilyRegistrationService {

    // Properties
    public householdParent: FamilyRegistration;
    public years: FamilyRegistrationYear[];
    public defaultYear: FamilyRegistrationYear;
    public registerNewFamily: any;
    public students: FamilyRegistrationStudent[] = [];
    public redirectUrl: string;

    // Class Functions
    constructor(
        private http: HttpClient
    ) { }

    // Methods
    getORYears(yearId = 0, studentId = 0): Observable<FamilyRegistrationYear[]> {
        const queryString = '?yearId=' + yearId +
            '&studentId=' + studentId;
        return this.http.get<FamilyRegistrationYear[]>(System.apiURL.Student + 'GetORYears' + queryString);
    }

    saveRegisterParent(familyRegistration: FamilyRegistration): Observable<void> {
        return this.http.post<void>(System.apiURL.Student + 'SaveRegisterParent', familyRegistration);
    }

    registerParent(emailAddress: string, languageId: number, url: string, clientIP: string, clientMachineName: string, serverIP: string): Observable<string> {
        const data = [emailAddress, languageId, url, clientIP, clientMachineName, serverIP];
        return this.http.post<string>(System.apiURL.Student + 'RegisterParent', data);
    }

    sendRegisterParentEmail(emailAddress: string, languageId: number, url: string): Observable<boolean> {
        const data = [emailAddress, languageId, url];
        return this.http.post<boolean>(System.apiURL.Student + 'SendRegisterParentEmail', data);
    }

    parentAlreadyExists(familyRegistration: FamilyRegistration): Observable<boolean> {
        // PRE: edited family registration data with an email address
        // POST: sends to the server to see if that data is in use
        return this.http.post<boolean>(System.apiURL.Student + 'ParentAlreadyExist', familyRegistration);
    }

    getFamilyRegistrationAddressSettings(): Observable<FamilyRegistrationAddressSettings> {
        // POST: obtains the family registration address settings from the server
        return this.http.get<FamilyRegistrationAddressSettings>(System.apiURL.Student + 'GetFamilyRegistrationAddressSettings');
    }

    saveRegisterParentAddress(familyRegistration: FamilyRegistration): Observable<any> {
        // PRE: a family registration that has edited addresses
        // POST: saves the family registration addresses to the server
        return this.http.post<any>(System.apiURL.Student + 'SaveRegisterParentAddress', familyRegistration);
    }

    getFamilyRegistrationStudents(): Observable<FamilyRegistrationStudent> {
        // POST: obtains the starting data for a family registration student
        return this.http.get<FamilyRegistrationStudent>(System.apiURL.Student + 'GetFamilyRegistrationStudent');
    }

    studentAlreadyExists(students: FamilyRegistrationStudent[]): Observable<string[]> {
        // POST: returns a list of names indicating the duplicate students
        return this.http.post<string[]>(System.apiURL.Student + 'StudentAlreadyExist', students);
    }

    saveFamilyRegistrationStudents(students: FamilyRegistrationStudent[]): Observable<any> {
        // PRE: a set of family students
        // POST: saves the students to the server
        const queryString = '?ayIdentifier=' + this.householdParent.AyIdentifier;
        return this.http.post<any>(System.apiURL.Student + 'SaveFamilyRegistrationStudent' + queryString, students);
    }

    CheckExistingEmail(emailAddress: string): Observable<string> {
        const data = [emailAddress];
        return this.http.post<string>(System.apiURL.Student + 'CheckExistingEmail', data);
    }
}
